import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { resolver } from "../../API/middlewares/resolveRequests";
import { useSelector } from "react-redux";
import CoverBar from "./coverBar";
import { getUserProfileDetails } from "../../API/store/actions/auth";
import AboutUser from "./aboutUser";

const GuestProfileIndex = (props) => {
  const [userProfileData, setUserProfileData] = useState({});
  const userToken = useSelector((state) => state.login.userToken);
  const [id, setId] = useState("A5");

  const params = useParams();
  const guestId = params.id;
  const memberId = params.memberId;

  useEffect(() => {
    resolver(getUserProfileDetails, setUserProfileData, guestId, userToken);
  }, [guestId, id]);

  useEffect(() => {
    let NavElements = document.querySelectorAll(".itemNav");
    for (let i = 0; i < NavElements?.length; i++) {
      if (
        NavElements[i]?.children[0]?.classList?.contains("iconsActiveClass")
      ) {
        NavElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        NavElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      }
    }
  }, []);

  return (
    <>
      <CoverBar details={userProfileData?.data} />
      <AboutUser
        details={userProfileData?.data}
        id={id}
        setId={setId}
        memberId={memberId}
      />
    </>
  );
};

export default GuestProfileIndex;
